import {blue, green, lightBlue, orange, pink, purple, red} from '@mui/material/colors';
import {PaginationBO} from "@/model/global";
import {identity, isNumber, pickBy} from "lodash";
import isEmpty from "lodash/isEmpty";

export const colors = [
    pink[500],
    blue[500],
    orange[500],
    red[500],
    green[500],
    lightBlue[500],
    purple[500],
];

export const reviewStatus: { [key: number]: string } = {
    '-1': '未通过',
    '0': '待审核',
    "1": "已通过"
}

export const writeStatus: { [key: number]: string } = {
    '1': '进行',
    '2': "暂停",
    '3': "完成",
}


export const roleAlias: { [key: string]: string } = {
    patenter: "patenter",
    declarer: "declarer",
    personnel: "personnel",
    financer: "financer",
    processer: "processer",
    manager: "manager",
    marketing: "marketing",
    bulletin: "bulletin",
    superadmin: "superadmin"
}

export const removeEmptyValue = (obj: any) => {
    return pickBy(obj, (item) => isNumber(item) || !isEmpty(item));
}

export const permScope: { [key: string]: number } = {
    self: 5,
    nextDept: 4,
    thisDept: 3,
    custom: 2,
    all: 1
}

export const defaultPageParams: PaginationBO = {current: 1, size: 20}


export const mediaType: { [key: string]: string[] } = {
    audio: ["mp3", "flac", "ape", "wav", "acc", "ogg", "m4a"],
    video: ["mp4", "flv", "avi", "wmv", "mkv", "rm", "rmvb", "mov", "ogv"],
    image: ["bmp", "iff", "png", "gif", "jpg", "jpeg", "psd", "svg", "webp"],
    pdf: ["pdf"],
    word: ["doc", "docx"],
    ppt: ["ppt", "pptx"],
    excel: ["xls", "xlsx", "csv"],
    text: ["txt", "md", "html"],
    torrent: ["torrent"],
    zip: ["zip", "gz", "xz", "tar", "rar", "7z"],
    excute: ["exe"],
    android: ["apk"],
    php: ["php"],
    go: ["go"],
    python: ["py"],
    cpp: ["cpp"],
    c: ["c"],
    js: ["js", "jsx"],
};
